var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classes},[_c('span',{staticClass:"c-ellipsis-bullet"},[_vm._v(".")]),_c('span',{staticClass:"c-ellipsis-bullet"},[_vm._v(".")]),_c('span',{staticClass:"c-ellipsis-bullet"},[_vm._v(".")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-720aa702","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/snippets/Ellipsis.vue
// module id = null
// module chunks = 